function checkRequirement(value, pattern) {
    var regexp = new RegExp(pattern);
    var match = value.match(regexp);

    return (match !== null);
}

/**
 * Show/Hide password requirements
 */
function initPasswordRequirements() {
    var $passwordRequirements = $('.js-password-requirements');

    $passwordRequirements.focusin(function (event) {
        $(event.target).next().collapse('show');
    });

    $passwordRequirements.focusout(function (event) {
        $(event.target).next().collapse('hide');
    });

    $(document).keyup('input[name=password]', function (event) {
        var value = $(event.target).val();
        var $requirements = $('.js-password-requirement');

        $requirements.each(function (index) {
            if (checkRequirement(value, $($requirements[index]).data('pattern'))) {
                $($requirements[index]).addClass('password-requirements__item--met');
            } else {
                $($requirements[index]).removeClass('password-requirements__item--met');
            }
        });
    });
}

$(document).ready(function () {
    initPasswordRequirements();
});
